import React, { useState } from "react";
import {
  History, Bookmark, Plus, FileText, ChevronRight, ChevronDown,
  Clock, MapPin, Building2, Briefcase, Trash2, Check, Sparkles, Settings2, Calendar, X, Target, Heart, GraduationCap, Loader2, AlertCircle, CheckCircle2, Zap
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuthContext } from "../../hooks/useAuthContext";

const calculateAge = (birthday) => {
  if (!birthday) return "N/A";
  const birthDate = new Date(birthday);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

const OpportunitiesRightSidebar = ({ pastApplications = [], savedOpportunities = [], cvs = [], onDeleteCv, onSetDefaultCv, onUploadCv }) => {
  const { user, token, dispatch } = useAuthContext();
  return (
    <div className="flex flex-col gap-5">
      {/* Past Applications Section */}
      <div className="stat-card !p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-display font-bold text-foreground flex items-center gap-2">
            <History className="w-4 h-4 text-secondary" /> Past Applications
          </h3>
          <button className="text-xs text-secondary hover:underline cursor-pointer border-none bg-transparent">History</button>
        </div>
        <div className="flex flex-col gap-2">
          {pastApplications.length > 0 ? pastApplications.slice(0, 3).map((app) => (
            <div key={app.id} className="p-2.5 rounded-xl bg-muted/50 hover:bg-muted transition-colors cursor-pointer group">
              <div className="flex justify-between items-start mb-1">
                <h4 className="text-xs font-medium text-foreground truncate max-w-[130px]">{app.title}</h4>
                <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-medium ${
                  app.status === 'Accepted' ? 'bg-secondary/15 text-secondary' : 'bg-destructive/10 text-destructive'
                }`}>
                  {app.status}
                </span>
              </div>
              <div className="flex items-center justify-between text-[10px] text-muted-foreground mt-0.5">
                <span className="flex items-center gap-1"><Building2 className="w-3 h-3" />{app.org}</span>
                <span>{app.date}</span>
              </div>
            </div>
          )) : (
            <p className="text-xs text-muted-foreground text-center py-4">No applications history</p>
          )}
        </div>
      </div>

      {/* Saved Opportunities Section */}
      <div className="stat-card !p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-display font-bold text-foreground flex items-center gap-2">
            <Bookmark className="w-4 h-4 text-secondary" /> Saved
          </h3>
          <button className="text-xs text-secondary hover:underline cursor-pointer border-none bg-transparent">All</button>
        </div>
        <div className="flex flex-col gap-2">
          {savedOpportunities.length > 0 ? savedOpportunities.slice(0, 2).map((opp) => (
            <div key={opp.id} className="p-2.5 rounded-xl bg-muted/50 hover:bg-muted transition-colors cursor-pointer">
              <h4 className="text-xs font-medium text-foreground mb-1">{opp.title}</h4>
              <div className="flex justify-between items-center text-[10px] text-muted-foreground">
                <span>{opp.org}</span>
                <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {opp.deadline}</span>
              </div>
            </div>
          )) : (
            <p className="text-xs text-muted-foreground text-center py-4">No saved opportunities</p>
          )}
        </div>
      </div>

      {/* My CVs Section */}
      <div className="stat-card !p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-display font-bold text-foreground flex items-center gap-2">
            <FileText className="w-4 h-4 text-secondary" /> My CVs
          </h3>
          <button onClick={onUploadCv} className="text-xs text-secondary hover:underline cursor-pointer border-none bg-transparent flex items-center gap-0.5">
             <Plus size={12} strokeWidth={3} /> Add
          </button>
        </div>
        <div className="flex flex-col gap-1.5">
           {cvs.length > 0 ? (
             cvs.map(cv => (
              <div key={cv.id} className="group flex items-center gap-2 p-2 rounded-xl hover:bg-muted/50 transition-colors">
                <FileText className="w-3.5 h-3.5 text-muted-foreground flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-foreground truncate">{cv.name}</p>
                  <p className="text-[10px] text-muted-foreground">{cv.date}</p>
                </div>
                {cv.isDefault ? (
                  <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-secondary/15 text-secondary font-bold flex-shrink-0">Default</span>
                ) : (
                  <div className="opacity-0 group-hover:opacity-100 flex gap-1 transition-opacity flex-shrink-0">
                    <button onClick={() => onSetDefaultCv(cv.id)} className="text-[9px] px-1.5 py-0.5 rounded-full bg-muted text-muted-foreground hover:text-secondary border-none cursor-pointer">Set Default</button>
                    <button onClick={() => onDeleteCv(cv.id)} className="text-muted-foreground/50 hover:text-destructive border-none bg-transparent cursor-pointer">
                      <Trash2 className="w-3 h-3" />
                    </button>
                  </div>
                )}
              </div>
             ))
           ) : (
             <p className="text-[10px] text-muted-foreground text-center py-2">No CVs uploaded</p>
           )}
        </div>
      </div>

    </div>
  );
};

export default OpportunitiesRightSidebar;
